import { createSelector } from "reselect"
import { get, capitalize, isObject } from "lodash"

const getDisplayType = (state) => get(state, "modules.securityProfile.displayType")
const getTickerMIC = (_, props) => `${props.security.ticker} ${props.security.exchange}`
const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate
const getBase = (_, props) => props.base

const getViewType = createSelector(
  [getBase],
  (base) => {
    if (base) {
      return "Active"
    } else {
      return "Absolute"
    }
  },
)

function getDisplayTypeName(displayType) {
  let label = ""
  if (isObject(displayType)) {
    label = displayType.label
  } else {
    label = displayType
  }
  return capitalize(label)
}

export const getFileName = createSelector(
  [getTickerMIC, getDisplayType, getViewType, getStartDate, getEndDate],
  (securityId, displayType, viewType, startDate, endDate) =>
    `${securityId} ${capitalize(viewType)} ${getDisplayTypeName(displayType)} ${startDate} - ${endDate}`,
)
